<div class="va-card-change-container">
  <div class="va-card-current-period">
    {{ changeInfo.currentPeriod | displayValue }}
  </div>
  <div
    class="va-card-previous-period"
    *ngIf="changeInfo.previousPeriod"
    [ngClass]="{
      'positive-change':
        changeInfo.previousPeriodChangeType === changeType.POSITIVE_CHANGE,
      'negative-change':
        changeInfo.previousPeriodChangeType === changeType.NEGATIVE_CHANGE,
      'no-change': changeInfo.previousPeriodChangeType === changeType.NO_CHANGE
    }"
  >
    <ng-container
      *ngIf="
        changeInfo.previousPeriodChangeDirection ===
        changeDirection.UPWARD_CHANGE
      "
    >
      <mat-icon>arrow_drop_up</mat-icon>
    </ng-container>
    <ng-container
      *ngIf="
        changeInfo.previousPeriodChangeDirection ===
        changeDirection.DOWNWARD_CHANGE
      "
    >
      <mat-icon>arrow_drop_down</mat-icon>
    </ng-container>
    <span>{{ changeInfo.previousPeriod | displayValue }}</span>
  </div>
</div>
